import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { MobileScrollWrapper } from 'components/mobile/MobileScrollWrapper';
import { LoginForm } from 'components/site/forms/LoginForm';
import CSS from 'csstype';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { GlobalContext } from 'session/state/context';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const LoginPage = (): JSX.Element => {
    const { state } = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (state.loggedUserChecked && state.loggedUser) {
            navigate('/admin');
        }
    }, [state.loggedUserChecked, state.loggedUser]);

    if (state.loggedUser || !state.loggedUserChecked) {
        return null;
    }

    return (
        <MobileScrollWrapper disableMessage>
            <S_LoginPage>
                <S_Center>
                    <MinutePageHeader disableLogin={true} />
                    <MinutePageTitle title={Localization.GET_ACCESS}>
                        {/* {Localization.LOGIN_TO_BECOME}{' '}
                        <Link to="/create">{Localization.CREATE_A_MAP}</Link>{' '}
                        {Localization.AS_A_GUEST} */}
                    </MinutePageTitle>
                    <S_Row>
                        <S_Mid {...ANIMATION_APPEAR}>
                            <LoginForm />
                        </S_Mid>
                    </S_Row>
                </S_Center>
                <MinuteWhiteBg />
            </S_LoginPage>
        </MobileScrollWrapper>
    );
};

const S_LoginPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
    @media only screen and (min-width: 1260px) {
        min-width: 1260px;
    }
`;

const S_Center = styled.div`
    display: flex;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
    width: 100%;
    @media only screen and (min-width: 1260px) {
        width: 1260px;
    }
`;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const S_Mid = styled(motion.div)`
    border-radius: 7px;
    background: #efefef;
    width: 100%;
    margin: 0 0 50px 0;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    @media only screen and (min-width: 1260px) {
        width: 400px;
    }
`;
